import { useState } from "react";
import { Trash2 } from "lucide-react";

const PARTS = [["all", "All day"], ["morning", "Morning"], ["afternoon", "Afternoon"], ["evening", "Evening"]];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const PRESETS = [
  ["Christmas Day", "12-25", ""], ["Christmas season", "12-01", "12-31"], ["Boxing Day Junkanoo", "12-26", ""],
  ["New Year's Day Junkanoo", "01-01", ""], ["Majority Rule Day", "01-10", ""], ["Valentine's Day", "02-14", ""],
  ["Independence Day", "07-10", ""], ["Emancipation week", "08-01", "08-07"],
];
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const presetDates = (start, end) => {
  const today = ymd(new Date());
  let y = new Date().getFullYear();
  if (`${y}-${end || start}` < today) y += 1;
  return [`${y}-${start}`, end ? `${end < start ? y + 1 : y}-${end}` : ""];
};
export const fmtMd = (v) => {
  if (!v) return "";
  const p = v.split("-");
  const [y, m, d] = p.length === 3 ? p : ["", ...p];
  return `${MONTHS[Number(m) - 1]} ${Number(d)}${y ? `, ${y}` : ""}`;
};
export const count = (pl) => PARTS.reduce((n, [p]) => n + pl[p].length, 0);

export const PlaylistEditor = ({ id, tracks, value, onChange }) => {
  const [part, setPart] = useState("all");
  const ids = value[part];
  return (
    <div className="mu-pl" data-testid={`music-pl-${id}`}>
      <div className="mu-tabs" role="tablist">
        {PARTS.map(([p, label]) => (
          <button key={p} type="button" role="tab" aria-selected={part === p} onClick={() => setPart(p)} data-testid={`music-pl-${id}-tab-${p}`}>
            {label}{value[p].length > 0 && <b>{value[p].length}</b>}
          </button>
        ))}
      </div>
      {part !== "all" && <p className="mu-hint">Leave empty to use the “All day” tracks during the {part}.</p>}
      <div className="mu-chips">
        {tracks.map((t) => {
          const on = ids.includes(t.id);
          return (
            <button type="button" key={t.id} aria-pressed={on} className="mu-chip" data-testid={`music-pl-${id}-${part}-track-${t.id}`}
              onClick={() => onChange({ ...value, [part]: on ? ids.filter((x) => x !== t.id) : [...ids, t.id] })}>
              {on && <b>{ids.indexOf(t.id) + 1}</b>} {t.title}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const HolidayRow = ({ h, tracks, onChange, onRemove }) => (
  <details className="mu-day" open data-testid={`music-holiday-${h.id}`}>
    <summary className="mu-day-name">{h.name || "Untitled"} <span className="muted-sm">{fmtMd(h.start)}{h.end && ` – ${fmtMd(h.end)}`} · {count(h.playlist)} track{count(h.playlist) === 1 ? "" : "s"}</span></summary>
    <div className="mu-hol-fields">
      <input value={h.name} maxLength={60} placeholder="Name, e.g. Christmas" onChange={(e) => onChange({ ...h, name: e.target.value })} data-testid="music-holiday-name-input" />
      <label>From <input type="date" value={h.start} required onChange={(e) => onChange({ ...h, start: e.target.value })} data-testid="music-holiday-start" /></label>
      <label>To <input type="date" value={h.end} min={h.start} onChange={(e) => onChange({ ...h, end: e.target.value })} data-testid="music-holiday-end" /> <span className="muted-sm">(optional)</span></label>
      <button type="button" className="ad-icon-btn" onClick={onRemove} aria-label="Remove special date" data-testid="music-holiday-remove"><Trash2 size={15} /></button>
    </div>
    <PlaylistEditor id={h.id} tracks={tracks} value={h.playlist} onChange={(pl) => onChange({ ...h, playlist: pl })} />
  </details>
);
